import { ReactNode } from "react";

import { Result } from "antd";

interface EmptyStatesProps {
  icon: ReactNode;
  title: string;
  description: string;
  actions?: ReactNode[];
}

const EmptyStates = ({ icon, title, description, actions = [] }: EmptyStatesProps) => {
  return <Result icon={icon} title={title} subTitle={description} extra={actions} />;
};

export default EmptyStates;
